











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.Graph.TemporalPercCommand')
    
    export class TemporalPercCommand {
        constructor( dateBeginning: Date, dateEnd: Date, binId: number, sensorId: number, minVolume: number, maxVolume: number, resolution: number ) {
            
                this.dateBeginning = dateBeginning;
            
                this.dateEnd = dateEnd;
            
                this.binId = binId;
            
                this.sensorId = sensorId;
            
                this.minVolume = minVolume;
            
                this.maxVolume = maxVolume;
            
                this.resolution = resolution;
            
        }

        
            public dateBeginning: Date;
        
            public dateEnd: Date;
        
            public binId: number;
        
            public sensorId: number;
        
            public minVolume: number;
        
            public maxVolume: number;
        
            public resolution: number;
        
    }

    export interface ITemporalPercCommand {
        
            dateBeginning: Date;
        
            dateEnd: Date;
        
            binId: number;
        
            sensorId: number;
        
            minVolume: number;
        
            maxVolume: number;
        
            resolution: number;
        
    }

    export async function temporalPerc( command: TemporalPercCommand ): Promise<CommandResult<any>>
    export async function temporalPerc( { dateBeginning, dateEnd, binId, sensorId, minVolume, maxVolume, resolution }: ITemporalPercCommand ): Promise<CommandResult<any>>
    export async function temporalPerc( model: any ): Promise<CommandResult<any>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<any>;

        if(model instanceof TemporalPercCommand) {
            result = await endpoint.send<CommandResult<any>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<any>>( new TemporalPercCommand( model['dateBeginning'], model['dateEnd'], model['binId'], model['sensorId'], model['minVolume'], model['maxVolume'], model['resolution'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace TemporalPercCommand.ExtraneousTypes {
        

        
    }

